var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91667 3.08335C8.91667 4.69418 7.61083 6.00002 6 6.00002C4.38917 6.00002 3.08333 4.69418 3.08333 3.08335C3.08333 1.47252 4.38917 0.166687 6 0.166687C7.61083 0.166687 8.91667 1.47252 8.91667 3.08335Z",
    fill: "#100C20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 7.16669C2.05584 7.16669 0.75 8.47252 0.75 10.0834V11.8334H11.25V10.0834C11.25 8.47252 9.94416 7.16669 8.33333 7.16669H3.66667Z",
    fill: "#100C20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.817bae94e8fd51d4aa14622481c50391.svg";
export { ForwardRef as ReactComponent };